import React from 'react';
import PropTypes from 'prop-types';
import { Cell as CellSwitch, Row as TableRow, SortOrder } from '@els/els-react--table';
import kebabCase from 'lodash/kebabCase';

function getNextDetailSortOrder(currentSortBy, currentSortOrder, nextSortBy) {
  if (nextSortBy !== currentSortBy) {
    return SortOrder.ASC;
  }

  return currentSortOrder === SortOrder.ASC ? SortOrder.DESC : SortOrder.ASC;
}

function isDetailColumnSortable(isSortable, sortableColumns, columnValue) {
  return isSortable && (Object.keys(sortableColumns).length === 0 || sortableColumns[columnValue] !== undefined);
}

function ConditionsDetailsTableHeader({ rowProps, sortingProps, onSortChange }) {
  const { columns, isSemantic, messages, stickyConfig, tableName } = rowProps;
  const { isSortable, sortBy, updateSortBy, sortOrder, sortableColumns } = sortingProps;

  return (
    <TableRow isHead isSemantic={isSemantic} stickyConfig={stickyConfig}>
      {columns.map(
        ({ value, label, alignRight = null, iconOnly = null, width, headContentLeft, headContentRight, className }, colIndex) => {
          const colIsSortable = isDetailColumnSortable(isSortable, sortableColumns, value);
          const handleSort = () => {
            if (!colIsSortable) return;

            onSortChange(value, getNextDetailSortOrder(sortBy, sortOrder, value));
            updateSortBy(value);
          };

          return (
            <CellSwitch
              alignRight={alignRight}
              iconOnly={iconOnly}
              id={`${kebabCase(tableName)}-head-cell-${colIndex}`}
              isHead
              isSemantic={isSemantic}
              key={value}
              messages={messages}
              width={width}
              cellId={value}
              data-testid={value}
              rowIndex={-1}
              colIndex={colIndex}
              sortOrder={sortOrder}
              colIsSortable={colIsSortable}
              displaySortingArrow={isSortable && value === sortBy}
              onClick={handleSort}
              col={value}
              headContentLeft={headContentLeft}
              headContentRight={headContentRight}
              className={className}>
              {label}
            </CellSwitch>
          );
        }
      )}
    </TableRow>
  );
}

ConditionsDetailsTableHeader.propTypes = {
  rowProps: PropTypes.shape({
    columns: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        alignRight: PropTypes.bool,
        iconOnly: PropTypes.bool,
        width: PropTypes.string,
        headContentLeft: PropTypes.node,
        headContentRight: PropTypes.node,
      })
    ).isRequired,
    isSemantic: PropTypes.bool,
    messages: PropTypes.shape({}),
    stickyConfig: PropTypes.shape({}),
    tableName: PropTypes.string,
  }).isRequired,
  sortingProps: PropTypes.shape({
    isSortable: PropTypes.bool,
    sortBy: PropTypes.string,
    updateSortBy: PropTypes.func,
    sortOrder: PropTypes.string,
    sortableColumns: PropTypes.shape({}),
  }).isRequired,
  onSortChange: PropTypes.func.isRequired,
};

export default ConditionsDetailsTableHeader;
